import React, { useState, useEffect } from "react";
import { Tab, Tabs, Container, Row, Col, Card } from "react-bootstrap";
import ReportbyDateFilter from "../Components/Finance/ReportbyDateFilter";
import ReportByNo from "../Components/Finance/ReportByNo";
import ReportByNo_CustomerService from "../Components/CustomerServices/ReportByNo_CustomerService";
import Header_Finance from "../Components/Finance/Header_Finance";
import CustomerService_Header from "../Components/CustomerServices/CustomerService_Header";
import Header_PartnerJazzcash from "../Components/PartnerJazzcash/Header_PartnerJazzcash";
import PartnerReportbyDateFilter from "../Components/PartnerJazzcash/PartnerReportbyDateFilter";
import PartnerReportByNo from "../Components/PartnerJazzcash/PartnerReportByNo";


const Report = () => {
  const [userData, setUserData] = useState(null);

  // Load user data from sessionStorage on component mount
  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (user) {
      setUserData(user);
    } else {
      console.log("No user found in sessionStorage");
    }
  }, []);

  // Render content based on user role
  if (userData && userData.userRole === "Finance") {
    return (
      <div className="container-fluid">
        <Header_Finance />

        <Container className="mt-4">
          <Tabs
            defaultActiveKey="reportByDateFilter"
            id="report-tabs"
            className="mb-3"
          >
            {/* Tab for Date Filter Report */}
            <Tab eventKey="reportByDateFilter" title="Report by Date Range">
              <Row className="mt-3">
                <Col>
                  <Card className="shadow-lg">
                    <Card.Header>
                      <div className="row">
                        <div className="col-md-8">
                          <h5>Generate Report by Date Range</h5>
                        </div>
                      </div>
                    </Card.Header>
                    <Card.Body>
                      <ReportbyDateFilter /> {/* Remove search query prop */}
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Tab>

            {/* Tab for MSISDN Report */}
            <Tab eventKey="reportByNo" title="Report by MSISDN">
              <Row className="mt-1">
                <Col>
                  <Card className="shadow-lg">
                    <Card.Header>
                      <div className="row">
                        <div className="col-md-8">
                          <h5>Generate Report by MSISDN</h5>
                        </div>
                      </div>
                    </Card.Header>
                    <Card.Body>
                      <ReportByNo /> {/* Remove search query prop */}
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Tab>
          </Tabs>
        </Container>
      </div>
    );
  } else if (userData && userData.userRole === "CustomerService") {
    return (
      <div className="">
        <CustomerService_Header />
        <ReportByNo_CustomerService /> {/* Remove search query prop */}
      </div>
    );
  } else if (userData && userData.userRole === "JazzCash") {
    return (
      <div className="container-fluid">
        <Header_PartnerJazzcash />
        <div className="mt-4">
          <Tabs
            defaultActiveKey="reportByDateFilter"
            id="report-tabs"
            className="mb-3"
          >
            {/* Tab for Date Filter Report */}
            <Tab eventKey="reportByDateFilter" title="Report by Date Range">
              <Row className="mt-3">
                <Col>
                  <Card className="shadow-lg">
                    <Card.Header>
                      <div className="row">
                        <div className="col-md-8">
                          <h5>Generate Report by Date Range</h5>
                        </div>
                      </div>
                    </Card.Header>
                    <Card.Body>
                      <PartnerReportbyDateFilter />
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Tab>

            {/* Tab for MSISDN Report */}
            <Tab eventKey="reportByNo" title="Report by MSISDN">
              <Row className="mt-1">
                <Col>
                  <Card className="shadow-lg">
                    <Card.Header>
                      <div className="row">
                        <div className="col-md-8">
                          <h5>Generate Report by MSISDN</h5>
                        </div>
                      </div>
                    </Card.Header>
                    <Card.Body>
                      <PartnerReportByNo /> {/* Remove search query prop */}
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Tab>
          </Tabs>
        </div>
      </div>
    );
  } else {
    return (
      <div className="text-center mt-5">
        You do not have permission to view this page.
      </div>
    );
  }
};

export default Report;
